import { Alert, AlertColor, AlertTitle, Box, Button } from '@mui/material';
import React, { FC } from 'react';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import WarningOutlined from '@mui/icons-material/WarningAmberOutlined';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';

interface IPolicyAlert {
	title: string;
	children: React.ReactNode;
	onActionClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	actionText?: string;
	type: AlertColor;
	href?: string;
	hideBorder?: boolean;
	onCloseAction?: () => void;
}

const icons = {
	error: <ErrorOutline fontSize='large' />,
	info: <InfoOutlined fontSize='large' />,
	success: <CheckCircleOutline fontSize='large' />,
	warning: <WarningOutlined fontSize='large' />,
};

const PolicyAlert: FC<IPolicyAlert> = ({
	title,
	children,
	onActionClick,
	actionText,
	type,
	href,
	hideBorder,
	onCloseAction,
}) => {
	return (
		<Alert
			closeText='Close'
			onClose={onCloseAction}
			severity={type}
			icon={icons[type]}
			sx={(theme) => ({
				mt: 3,
				borderRadius: 2,
				borderWidth: '1px',
				borderStyle: hideBorder ? 'none' : 'solid',
				borderColor: `${type}.main`,
				[theme.breakpoints.down('md')]: {
					mx: 1,
					mt: 3,
				},
			})}
		>
			<AlertTitle sx={{ fontSize: '1.2rem' }}>{title}</AlertTitle>
			{children}
			<Box my={2}>
				{onActionClick && (
					<Button
						sx={{
							color: `${type}.main`,
							borderColor: `${type}.main`,
							':hover': {
								backgroundColor: `${type}.main`,
								borderColor: `${type}.main`,
								color: 'white',
							},
						}}
						variant='outlined'
						onClick={onActionClick}
					>
						{actionText ?? 'Action Button'}
					</Button>
				)}
				{href && (
					<Button
						sx={{
							color: `${type}.main`,
							borderColor: `${type}.main`,
							':hover': {
								backgroundColor: `${type}.main`,
								borderColor: `${type}.main`,
								color: 'white',
							},
						}}
						variant='outlined'
						href={href}
						target='_blank'
					>
						{actionText ?? 'Action Button'}
					</Button>
				)}
			</Box>
		</Alert>
	);
};

export default PolicyAlert;
